<script>
import options from "./ContactStepComments.options"
export default options
</script>

<template>
    <article class="nyk-signup-step nyk-contact-step-comments">
        <div class="nyk-signup-step__content" :class="contentClassnames">
            <div class="nyk-signup-step__content__section--66-width nyk-signup-step__content__section--full-width-mobile">
                <div class="nyk-signup-step__header">
                    <h2 class="nyk-signup-step__title">{{ currentStepTexts.title }}</h2>
                    <p class="nyk-signup-step__stepcounter">Step {{ stepCounterText }}</p>
                </div>
            </div>

            <div class="nyk-signup-step__mt-auto nyk-signup-step__content__section--full-width">
                <div class="nyk-signup-step__mt-auto nyk-signup-step__content__section--66-width nyk-signup-step__content__section--full-width-mobile">
                    <input class="nyk-signup-step__input"
                           :placeholder="labels.commentPlaceholder ?? 'Evt. kommentar'"
                           v-model="commentsInput" />
                    <p class="nyk-signup-step__input-error-msg">
                        <template v-if="displayInputError && showFieldErrorMessage('comment')">
                            {{ labels.commentErrorMessage}}
                        </template>
                    </p>
                </div>

                <SignupStepActions :previousStepCallback="previousStepCallback"
                                   :nextStepCallback="() => nextStepCallback([{ field: 'comment', value: commentsInput }])"
                                   :nextStepButtonText="currentStepTexts.next"
                                   :stepCounterText="stepCounterText"
                                   :hasPreviousStep="hasPreviousStep"
                                   :redirectUrl="redirectUrl" />
            </div>
        </div>
        <div v-if="labels.disclaimerText" class="nyk-signup-step__disclaimer-text">
            <small v-html="labels.disclaimerText"></small>
        </div>
    </article>
</template>
